
import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router';
import { useSnackbar } from 'notistack';
import { Paper, Button, Grid, TextField, Tooltip, } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import EditIcon from '@material-ui/icons/Edit';
import InfoIcon from '@material-ui/icons/Info';
import { getPermissionKey } from "..";
import { checkApiStatus, checkPermission } from '../../utils_v2';
import { PageLoader, STableLoader } from '../../shared_elements';
import { assetTypeValues, } from '../../../constants';
import { globalGetService, globalPutService, globalPostService } from '../../../globalServices';
import { trackActivity } from '../../../utils/mixpanel';
import { mtInstance, titanAviInstance } from '../../../shared/components';
const TALGInfo = ({ params, assetInfoData }) => {
  const [lgData, setLGData] = useState({});
  const [oldData, setOldData] = useState({});
  const [isEdit, setEdit] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [skeletonLoader, setSkeletonLoader] = useState(false);
  const [error, setError] = useState({});
  const { enqueueSnackbar } = useSnackbar();

useEffect(()=>{
    getLGInfo()
  },[])

  const onFieldChange = (key, value) => { setLGData({ ...lgData, [key]: value }); }

  const getLGInfo = (query) => {
     setLoading(true);
          globalGetService(`console/v2/${params.type}/${params.aircraft_slug}/lg_information/`, query)
          .then(response=>{
          setLoading(false);
          if(checkApiStatus(response)){
            setLGData(response.data.data)
          }
        })
  }

  const onEditLGInfo = () => {
    let validationInputs = {}
    if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === '' })) {
      setLoading(true);
      let payload = Object.assign({}, lgData)
      globalPutService(`console/v2/${params.type}/${params.aircraft_slug}/lg_information/`, payload)
        .then(response => {
          setLoading(false);
          if (checkApiStatus(response)) {
            enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
            trackActivity('Console Management', {data:JSON.stringify(payload), page_title: 'LG Information', asset_type: assetTypeValues[assetInfoData?.asset_type.type].label, asset_name: assetInfoData?.serial_number, event_type: 'Item Edited', event_desc: 'Edited LG Information Details data from Edit Aircraft Configuration Details form' });
            setEdit(false);
          }
        })
        .catch(error=>{
         setLoading(false);
        })
    } else {
      setError(validationInputs)
    }
  }

  return (
    <div style={{ position: 'relative' }}>
      <div className="console-forms-fields" style={{ height: `${window.innerHeight - (isEdit ? 260 : 215)}px`, padding: '10px', overflow: 'auto' }}>
        <p style={{ textAlign: 'right', height: '20px' }}>
          {checkPermission('technical_specs', getPermissionKey(params.type), 'U') && !isEdit ?
            <span style={{ cursor: 'pointer' }}>
              <EditIcon onClick={() => { setEdit(true); }} fontSize="small" color='primary' />
            </span> : null
          }
        </p>
        {skeletonLoader ? < STableLoader count={3} size={7} /> : <>
          <Grid container spacing={1}>
            <Grid item md={3}>
              <TextField
                disabled={!isEdit}
                name='wheel_manufacturer'
                label='Wheels & Brakes Manufacturer'
                value={lgData?.wheel_manufacturer || ''}
                fullWidth
                margin="normal"
                inputProps={{ maxLength: 255 }}
                onChange={(e) => onFieldChange('wheel_manufacturer', e.target.value.trimStart())}
                InputLabelProps={{ shrink: true }}
                variant='outlined'
              />
            </Grid>
            <Grid item md={3}>
              <TextField
                disabled={!isEdit}
                name='brake_type'
                label="Brake Type"
                value={lgData?.brake_type || ''}
                fullWidth
                margin="normal"
                inputProps={{ maxLength: 255 }}
                onChange={(e) => onFieldChange('brake_type', e.target.value.trimStart())}
                InputLabelProps={{ shrink: true }}
                variant='outlined'
              />
            </Grid>
            <Grid item md={3}>
              <TextField
                disabled={!isEdit}
                name='brake_fans'
                label="Brake Fans"
                value={lgData?.brake_fans || ''}
                fullWidth
                margin="normal"
                inputProps={{ maxLength: 255 }}
                onChange={(e) => onFieldChange('brake_fans', e.target.value.trimStart())}
                InputLabelProps={{ shrink: true }}
                variant='outlined'
              />
            </Grid>
          </Grid>
        </>
        }
      </div>
      {isEdit ?
        <Paper square style={{ padding: '10px', borderTop: '1px solid #d7d7d7' }}>
          <ul className="list-inline">
            <li className="list-inline-item">
              <Button onClick={() => { setError(''); setEdit(false); getLGInfo() }} color="primary" size='small' variant="outlined">Cancel</Button>
            </li>
            <li className="list-inline-item">
              <Button onClick={onEditLGInfo} color="primary" size='small' variant="contained">SAVE</Button>
            </li>
          </ul>
        </Paper> : null
      }
      {isLoading ? <PageLoader /> : null}
    </div>
  )
}

export default withRouter(TALGInfo)
